import * as layers from './getElevationLayer';

export const {
  getFrontendLayer,
  getBackendLayer,
} = layers;

export default undefined;
